export default __webpack_public_path__ + "static/media/mobile-locator-finder.57836220.svg";